export class CookbookTreeNode {
    isOwn: boolean;
    data: number;
    label: string;
    id_Book: number;
    id_Section: number;
    children: CookbookTreeNode[];
    isRoot: boolean;
    selectable: boolean;
    styleClass: string;
    parent: CookbookTreeNode;
    expanded = false;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/cookbook-tree-model.ts